// disable COPY and RIGHT CLICK on website

document.addEventListener("contextmenu", function (e){
    e.preventDefault();
}, false);

// --- TheWallArt -----
// ----- Fix 10% off the first order ---------

// Get all menu items
const menuItems = document.querySelectorAll('.dropdown__nav li a');
// Attach event listener to each menu item
menuItems.forEach(item => {
  item.addEventListener('click', (event) => {
    
    // Log the clicked menu item's URL
    //console.log('Clicked menu item URL:', event.target.href);
    // Or log the menu item's text content
    //console.log('Clicked menu item text:', event.target.textContent);
    //alert(event.target.textContent)
    if(event.target.textContent === "10% OFF THE FIRST ORDER")      {
      //alert("ok");
            document.getElementById('idBtnPopupNewsletter').click();
    }
    
  });
});

//--- on MOBILE
const menuItemsMob = document.querySelectorAll('.menu-drawer__item a');
// Attach event listener to each menu item
menuItemsMob.forEach(item => {
  item.addEventListener('click', (event) => {
    
    // Log the clicked menu item's URL
    //console.log('Clicked menu item URL:', event.target.href);
    // Or log the menu item's text content
    //console.log('Clicked menu item text:', event.target.textContent);
    //alert(event.target.textContent)
    if(event.target.textContent === "10% OFF THE FIRST ORDER")      {
      //alert("ok");
            // close Menu
            //document.querySelectorAll('button.drawer__close').click();
            var els = document.getElementsByClassName("drawer__close");

            Array.prototype.forEach.call(els, function(el) {
                // Do stuff here
                //console.log(el.tagName);
                el.click();
                
            });

        
            // open popup
            document.getElementById('idBtnPopupNewsletter').click();
            
                      
    }
    
  });
});




// ----- Fix 10% off the first order --------- LINK on HOME PAGE Bottom

const menuItems1 = document.querySelectorAll('.card-promotion__link');
// Attach event listener to each menu item
menuItems1.forEach(item => {
  item.addEventListener('click', (event) => {
    //alert("ok"); 
    // Log the clicked menu item's URL
    //console.log('Clicked menu item URL:', event.target.href);
    // Or log the menu item's text content
    //console.log('Clicked menu item text:', event.target.textContent);
    //alert(event.target.textContent)
    //alert(event.target.ariaLabel)  
  
    if(event.target.textContent.includes("10% OFF THE 1ST ORDER"))      {                                   
      document.getElementById('idBtnPopupNewsletter').click();             
    }
    
  });
});



  